module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-ar-SA.819d0d66.jpg";